import { produce } from 'immer'
import type { State } from '../typings'

export type PrevScreenAction = { type: 'prev' }

export const prevScreenAction = (state: State) =>
  produce(state, (draft) => {
    draft.stack.pop()
  })

export const prevScreenActionCreator = (): PrevScreenAction => ({
  type: 'prev',
})
